import { render, staticRenderFns } from "./ConsoleList.vue?vue&type=template&id=2b056b7e&scoped=true"
import script from "./ConsoleList.vue?vue&type=script&lang=js"
export * from "./ConsoleList.vue?vue&type=script&lang=js"
import style0 from "./ConsoleList.vue?vue&type=style&index=0&id=2b056b7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b056b7e",
  null
  
)

export default component.exports